import MainLanding from "./components/MainLanding";
import './App.css';

export default function App() {
  return <MainLanding />;
}
